import GroupedTable from "./GroupedTable";
import UngroupedTable from "./UngroupedTable";

export { GroupedTable, UngroupedTable };



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/Display/index.js